<!-- 交接班信息上报接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/comUpwardStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                "cmd": "reportShift",
                "parkCode": "2KM9J7GC",
                "reportTime": "20170929162050",
                "shiftList": [
                    {
                        "abOutUncollectedCount": 1,
                        "abOutUncollectedMoney": 1,
                        "abnormalAmount": 2,
                        "abnormalCount": 2,
                        "gateOutUncollectedCount": 0,
                        "gateOutUncollectedMoney": 0,
                        "loginInTime": "20170928101749",
                        "loginOutTime": "20170929162040",
                        "normalAmount": 47,
                        "normalCount": 9,
                        "remark": "",
                        "shiftArrearCount": 2,
                        "shiftArrearMoney": 6,
                        "shiftDiscountCount": 2,
                        "shiftDiscountMoney": 4,
                        "shiftFromName": "hy",
                        "shiftMoney": 55,
                        "shiftOriginType": 1,
                        "shiftTime": "20170929162040",
                        "shiftToName": "x86",
                        "shiftTotalCount": 11
                    }
                ]
            },
            responseCode: {
                "data": {
                }, "message": "业务成功", "resultCode": 0, "status": 1
            },
            infoData: {
                explain: "智慧停车开放平台主动上报停车场交接班信息到第三方接入系统",
                urlPattern:this.commonUrls.third+"reportShift",
                precondition: "VEMS 2.10.5及以上版本",
                fitSystem: "VEMS传统停车场",
                pattern: "第三方接入系统提供接口, 智慧停车开放平台主动请求",
                frequency:"实时触发",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号' },
                        { info1: 'reportTime', info2: '是', info3: 'String', info4: '上报时间，yyyyMMddHHmmss' },
                        { info1: 'shiftList', info2: '是', info3: 'JSONArray', info4: '' }
                        ]
                },{
                    titleName: 'shiftList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'shiftFromName', info2: '是', info3: 'String', info4: '交班人姓名' },
                        { info1: 'loginInTime', info2: '是', info3: 'String', info4: '登录时间，yyyyMMddHHmmss' },
                        { info1: 'loginOutTime', info2: '是', info3: 'String', info4: '登出时间，yyyyMMddHHmmss' },
                        { info1: 'shiftMoney', info2: '是', info3: 'Decimal', info4: '交接总金额' },
                        { info1: 'shiftArrearMoney', info2: '是', info3: 'Decimal', info4: '交接补缴金额' },
                        { info1: 'normalAmount', info2: '是', info3: 'Decimal', info4: '正常金额' },
                        { info1: 'abnormalAmount', info2: '是', info3: 'Decimal', info4: '异常金额' },
                        { info1: 'shiftDiscountMoney', info2: '是', info3: 'Decimal', info4: '交接优惠金额' },
                        { info1: 'shiftToName', info2: '是', info3: 'String', info4: '接班人姓名' },
                        { info1: 'shiftTime', info2: '是', info3: 'String', info4: '接班时间，yyyyMMddHHmmss' },
                        { info1: 'remark', info2: '是', info3: 'String', info4: '备注' },
                        { info1: 'shiftOriginType', info2: '是', info3: 'int', info4: '交接班来源类型，0未定义，1岗亭交接班，2中央收费处交接班' },
                        { info1: 'shiftTotalCount', info2: '是', info3: 'int', info4: '交接总收费次数' },
                        { info1: 'normalCount', info2: '是', info3: 'int', info4: '正常收费次数' },
                        { info1: 'abnormalCount', info2: '是', info3: 'int', info4: '异常收费次数' },
                        { info1: 'shiftArrearCount', info2: '是', info3: 'int', info4: '补缴次数' },
                        { info1: 'shiftDiscountCount', info2: '是', info3: 'String', info4: '人工优惠总次数' },
                        { info1: 'abOutUncollectedMoney', info2: '是', info3: 'Decimal', info4: '异常放行未收金额' },
                        { info1: 'abOutUncollectedCount', info2: '是', info3: 'int', info4: '异常放行未收次数' },
                        { info1: 'gateOutUncollectedMoney', info2: '是', info3: 'Decimal', info4: '遥控开闸未收金额' },
                        { info1: 'gateOutUncollectedCount', info2: '是', info3: 'int', info4: '遥控开闸未收次数' },
                        { info1: 'lockKey', info2: '是', info3: 'String', info4: '数据唯一标识' },
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [
                        ]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/upward/reportShift.vue